if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // this.upsellCheckboxes = document.querySelectorAll('.bundle-container .bundleCheck');
        
        this.upsellCheckboxes = document.querySelectorAll('.custom_oval_accessories_main input[type="radio"]');

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        //Ak custom code
          const checked = [...this.upsellCheckboxes].filter(cb => cb.checked).map(cb => cb.value);
        //Ak custom code

      let mainVariantId;

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      // config.body = formData;

      //Ak custom code
      if(checked.length == 0){
        config.body = formData;
      }else{
          // const formData = new FormData(this.form);
        const timestamp = Math.round(new Date().getTime()/1000);

         mainVariantId = formData.get('id');
        const mainQty = parseInt(formData.get('quantity')) || 1;

        const checkedVariants = [...this.upsellCheckboxes].filter(cb => cb.checked).map(cb => cb.value);

        //  remove default fields
        formData.delete('id');
        formData.delete('quantity');

        //  main product
        formData.append('items[0][id]', mainVariantId);
        formData.append('items[0][quantity]', mainQty);
        formData.append(`items[0][properties][_timestamp]`,timestamp);

      //  bundle items
        checkedVariants.forEach((variantId, index) => {
          const i = index + 1;

          if(variantId){
            formData.append(`items[${i}][id]`, variantId);
            formData.append(`items[${i}][quantity]`, mainQty);
            formData.append(`items[${i}][properties][_timestamp]`,timestamp);

            //parent id link
            formData.append(
              `items[${i}][parent_id]`,
              mainVariantId
            );
          }
        });

         config.body = formData;
      }
      //Ak custom code


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
               if(checked.length == 0){
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
               }else{
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: mainVariantId,
                    errors: response.errors || response.description,
                    message: response.message,
                  });

               }
              // publish(PUB_SUB_EVENTS.cartError, {
              //   source: 'product-form',
              //   productVariantId: formData.get('id'),
              //   errors: response.errors || response.description,
              //   message: response.message,
              // });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              //  publish(PUB_SUB_EVENTS.cartUpdate, {
              //     source: 'product-form',
              //     productVariantId: formData.get('id'),
              //     cartData: response,
              //   });
              if(checked.length == 0){
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }else{
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: mainVariantId,
                  cartData: response,
                });
              }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
